import React, { useRef, useEffect, useState } from "react";
import Sidebar, { SidebarHandles } from "../../Components/Sidebar/Sidebar";
import KPITable, { KPIRow } from "../../Components/KPITable/KPITable";
import { getSOPsDocumentAPI } from "../../apiRequests/getTimelyReviewSOPS/getLogDataAPI";
import { DeviceManagementData, TableRowData } from "../../types/dataType";
import {
    CAPA_MANAGEMENT_PROCESS_POINT,
    DEVICE_MANAGEMENT_PROCESS_POINT,
    INTERNAL_AUDIT_FREQUENCY_PROCESS_POINT,
    KPI_LIST,
    KPI_LOADING_MAP,
    KPI_MAP,
    KPI_PROGRESS_MAP,
    KPI_STATUS,
    KPI_STATUS_MAP,
    KPI_THRESHOLD,
    MANAGEMENT_REVIEW_PROCESS_POINT,
    NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT,
    NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT,
    PURCHASE_ACCEPTANCE_PROCESS_POINT,
    SOP_REVIEW_PROCESS_POINT,
    TRAINING_COMPETENCY_PROCESS_POINT,
    TRAINING_MANAGEMENT_PROCESS_POINT,
} from "../../constants/kpiList";
import { getAllUsersThunk } from "../../store/user/thunkMiddlewares";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { AssignedDto, UserDto } from "../../types/user.dto";
import { QuarterAndYear } from "../../types/quarterAndYear";
import { getTrainingRecordByPeriodAPI } from "../../apiRequests/training-management/getTrainingRecordsAPI";
import { computeDeviceManagementKPI, convertToPercentage, findCurrentQuarter } from "../../utils/commonUtils";
import { APP_URLS, BLANK_STRING, OUT_OF_SERVICE_STATUS } from "../../constants/appConstants";
import { getCAPADataByYearAPI } from "../../apiRequests/capa-management/getCAPADataAPI";
import CAPAManagement from "../CAPAManagement/CAPAManagement";
import "./styles.css";
import TrainingManagement from "../TrainingManagement/TrainingManagement";
import TrainingCompetency from "../TrainingCompetency/TrainingCompetency";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import PurchaseAcceptance from "../PurchaseAcceptance/PurchaseAcceptance";
import SOPReview from "../SOPReview/SOPReview";
import LoadingPage from "../../Components/LoadingPage/LoadingPage";
import NonconformanceAndInvestigation from "../NonconformanceAndInvestigation/NonconformanceAndInvestigation";
import { getNonconformanceAndInvestigationKPIDataByPeriodAPI } from "../../apiRequests/nonconformance-and-investigation/getNonconformanceAndInvestigationKPIDataAPI";
import { getInternalAuditDataAPI } from "../../apiRequests/internal-audit/getInternalAuditDataAPI";
import InternalAudit from "../InternalAudit/InternalAudit";
import { getManagementReviewsDataAPI } from "../../apiRequests/management-reviews/getManagementReviewsDataAPI";
import ManagementReviews from "../ManagementReviews/ManagementReviews";
import { getDeviceManagementAPI } from "../../apiRequests/device-management/getDeviceManagementAPI";
import DeviceManagement from "../DeviceManagement/DeviceManagement";
import { getNumberOfCreatedAndResolvedDataByQuarterAPI } from "../../apiRequests/number-of-created-and-resolved/getNumberOfCreatedAndResolvedDataAPI";
import NumberOfCreatedAndResolved from "../NumberOfCreatedAndResolved/NumberOfCreatedAndResolved";
import { LIST_PROJECT_KEY } from "../NumberOfCreatedAndResolved/constants";
import { getPurchaseAcceptanceDataByYearAPI } from "../../apiRequests/purchase-acceptance/getPurchaseAcceptanceDataByYearAPI";
import { useNavigate } from "react-router-dom";
const DashboardPage = () => {
    const sidebarRef = useRef<SidebarHandles>(null);
    const [kpiProgressMap, setKPIProgressMap] = useState<Map<string, string>>(KPI_PROGRESS_MAP);
    const [kpiLoading, setKPILoading] = useState<Map<string, boolean>>(KPI_LOADING_MAP);
    const [kpiStatus, setKPIStatus] = useState<Map<string, number>>(KPI_STATUS_MAP);
    const [timelyReviewKPIData, setTimelyReviewKPIData] = useState<TableRowData[]>([]);
    const [dataTRCs, setDataTRCs] = useState<any[]>([]);
    const [dataCAPAs, setDataCAPAs] = useState<any>({});
    const [dataPAs, setDataPAs] = useState<any[]>([]);
    const [dataNAIs, setDataNAIs] = useState<any[]>([]);
    const [dataIAs, setDataIAs] = useState<any[]>([]);
    const [dataMRs, setDataMRs] = useState<any[]>([]);
    const [deviceManagementData, setDeviceManagementData] = useState<DeviceManagementData[]>([]);
    const [NumberOfCreatedAndResolvedData, setNumberOfCreatedAndResolvedData] = useState<any[]>([]);
    const dispatch = useAppDispatch();
    const userState = useAppSelector((state) => state.user);
    const navigate = useNavigate();
    useEffect(() => {
        loadDataOfSOPsReviewTimelyCompletionOfReviews();
        getKPIOfTrainingCompetency();
        getKPIOfTrainingManagementForCurrentQuarter();
        getKPIOfCAPAManagementForCurrentQuarter();
        getKPIOfPurchaseAcceptanceForCurrentQuarter();
        getKPIOfNonconformanceAndInvestigationForCurrentQuarter();
        getKPIOfInternalAudit();
        getKPIOfManagementReviews();
        getKPIOfDeviceManagement();
        getKPIOfNumberOfCreatedAndResolved();
    }, []);

    useEffect(() => {
        const getCurrentYearAndQuarter = () => {
            const month = new Date().getMonth() + 1;
            const year = new Date().getFullYear();
            return { year, quarter: Math.ceil(month / 3) };
        };
        const currentQuarter = getCurrentYearAndQuarter();
        getKPIOfTrainingCompetencyForCurrentQuarter(currentQuarter);
    }, [userState.users]);

    const getKPIOfNonconformanceAndInvestigationForCurrentQuarter = async () => {
        setKPILoading((prev) => new Map(prev).set(NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT, true));
        const currentYear = new Date().getFullYear();
        const currentQuarter = Math.floor(new Date().getMonth() / 3) + 1;
        const dataNAIs: any = await getNonconformanceAndInvestigationKPIDataByPeriodAPI(currentYear, currentQuarter);
        setDataNAIs(dataNAIs);

        const currentNAI = dataNAIs.find((data: any) => data.yearNAIs.title.includes(currentYear));

        const selectedQuarter = findCurrentQuarter(currentNAI?.quarterNAIs, currentYear, currentQuarter);
        if (!selectedQuarter) {
            setKPIProgressMap((prev) => new Map(prev).set(NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT, "No current quarter data"));
            setKPIStatus((prev) => new Map(prev).set(NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT, KPI_STATUS.NOT_FOUND));
            setKPILoading((prev) => new Map(prev).set(NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT, false));
            return;
        }

        const total = currentNAI?.quarterNAIs[selectedQuarter || BLANK_STRING].data.length;
        const passed = currentNAI.quarterNAIs[selectedQuarter || BLANK_STRING].data.filter((trc: any) => trc.status === "PASSED").length;

        const KPI = Number(passed / total);
        setKPIProgressMap((prev) => new Map(prev).set(NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT, convertToPercentage(KPI)));
        setKPIStatus((prev) => new Map(prev).set(NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT, isKPINonconformanceAndInvestigationPassed(KPI)));
        setKPILoading((prev) => new Map(prev).set(NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT, false));
    };
    const isKPINonconformanceAndInvestigationPassed = (kpi: number) => {
        return kpi == KPI_THRESHOLD[NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };
    const getKPIOfTrainingCompetency = async () => {
        setKPILoading((prev) => new Map(prev).set(TRAINING_COMPETENCY_PROCESS_POINT, true));
        await dispatch(getAllUsersThunk());
        setKPILoading((prev) => new Map(prev).set(TRAINING_COMPETENCY_PROCESS_POINT, false));
    };

    const getKPIOfTrainingManagementForCurrentQuarter = async () => {
        setKPILoading((prev) => new Map(prev).set(TRAINING_MANAGEMENT_PROCESS_POINT, true));
        const currentYear = new Date().getFullYear();
        const currentQuarter = Math.floor(new Date().getMonth() / 3) + 1;
        const dataTRCs: any = await getTrainingRecordByPeriodAPI(currentYear, currentQuarter);
        setDataTRCs(dataTRCs);
        const currentTRC = dataTRCs.find((data: any) => data.yearTRCs.title.includes(currentYear));
        const selectedQuarter = findCurrentQuarter(currentTRC?.quarterTRCs, currentYear, currentQuarter);
        if (!selectedQuarter) {
            setKPIProgressMap((prev) => new Map(prev).set(TRAINING_MANAGEMENT_PROCESS_POINT, "No current quarter data"));
            setKPIStatus((prev) => new Map(prev).set(TRAINING_MANAGEMENT_PROCESS_POINT, KPI_STATUS.NOT_FOUND));
            setKPILoading((prev) => new Map(prev).set(TRAINING_MANAGEMENT_PROCESS_POINT, false));
            return;
        }
        const total = currentTRC.quarterTRCs[selectedQuarter || BLANK_STRING].data.length;
        const passed = currentTRC.quarterTRCs[selectedQuarter || BLANK_STRING].data.filter((trc: any) => trc.status === "PASSED").length;
        const KPI = Number(passed / total);
        setKPIProgressMap((prev) => new Map(prev).set(TRAINING_MANAGEMENT_PROCESS_POINT, convertToPercentage(KPI)));
        setKPIStatus((prev) => new Map(prev).set(TRAINING_MANAGEMENT_PROCESS_POINT, isKPITrainingManagementPassed(KPI)));
        setKPILoading((prev) => new Map(prev).set(TRAINING_MANAGEMENT_PROCESS_POINT, false));
    };

    const isKPITrainingManagementPassed = (kpi: number) => {
        return kpi >= KPI_THRESHOLD[TRAINING_MANAGEMENT_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };

    const getKPIOfCAPAManagementForCurrentQuarter = async () => {
        setKPILoading((prev) => new Map(prev).set(CAPA_MANAGEMENT_PROCESS_POINT, true));
        const currentYear = new Date().getFullYear();
        const dataCAPAs: any = await getCAPADataByYearAPI(currentYear.toString());
        setDataCAPAs(dataCAPAs);

        const currentCAPA = dataCAPAs.closedCAPAs.find((data: any) => data.yearCAPAs.title.includes(currentYear));
        const currentQuarter = Math.floor(new Date().getMonth() / 3) + 1;
        const selectedQuarter = findCurrentQuarter(currentCAPA?.quarterCAPAs, currentYear, currentQuarter);
        if (!selectedQuarter) {
            setKPIProgressMap((prev) => new Map(prev).set(CAPA_MANAGEMENT_PROCESS_POINT, "No current quarter data"));
            setKPIStatus((prev) => new Map(prev).set(CAPA_MANAGEMENT_PROCESS_POINT, KPI_STATUS.NOT_FOUND));
            setKPILoading((prev) => new Map(prev).set(CAPA_MANAGEMENT_PROCESS_POINT, false));
            return;
        }
        const total = currentCAPA.quarterCAPAs[selectedQuarter || BLANK_STRING].length;
        const passed = currentCAPA.quarterCAPAs[selectedQuarter || BLANK_STRING].filter((trc: any) => trc.status === "PASSED").length;
        const KPI = Number(passed / total);
        setKPIProgressMap((prev) => new Map(prev).set(CAPA_MANAGEMENT_PROCESS_POINT, convertToPercentage(KPI)));
        setKPIStatus((prev) => new Map(prev).set(CAPA_MANAGEMENT_PROCESS_POINT, isCAPAManagementPassed(KPI)));
        setKPILoading((prev) => new Map(prev).set(CAPA_MANAGEMENT_PROCESS_POINT, false));
    };

    const isCAPAManagementPassed = (kpi: number) => {
        return kpi >= KPI_THRESHOLD[CAPA_MANAGEMENT_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };

    const getKPIOfPurchaseAcceptanceForCurrentQuarter = async () => {
        const currentYear = new Date().getFullYear();
        const currentQuarter = Math.floor(new Date().getMonth() / 3) + 1;
        setKPILoading((prev) => new Map(prev).set(PURCHASE_ACCEPTANCE_PROCESS_POINT, true));
        const dataPAs: any = await getPurchaseAcceptanceDataByYearAPI(currentYear);
        setDataPAs(dataPAs);

        const currentPA = dataPAs.find((data: any) => data.yearGRNs.title.includes(currentYear));

        const selectedQuarter = findCurrentQuarter(currentPA?.quarterGRNs, currentYear, currentQuarter);

        if (!selectedQuarter) {
            setKPIProgressMap((prev) => new Map(prev).set(PURCHASE_ACCEPTANCE_PROCESS_POINT, "No current quarter data"));
            setKPIStatus((prev) => new Map(prev).set(PURCHASE_ACCEPTANCE_PROCESS_POINT, KPI_STATUS.NOT_FOUND));
            setKPILoading((prev) => new Map(prev).set(PURCHASE_ACCEPTANCE_PROCESS_POINT, false));
            return;
        }
        const total = currentPA.quarterGRNs[selectedQuarter || BLANK_STRING]?.length;
        const passed = currentPA.quarterGRNs[selectedQuarter || BLANK_STRING]?.filter((trc: any) => trc.status === "PASSED").length;
        const KPI = Number(passed / total);
        setKPIProgressMap((prev) => new Map(prev).set(PURCHASE_ACCEPTANCE_PROCESS_POINT, convertToPercentage(KPI)));
        setKPIStatus((prev) => new Map(prev).set(PURCHASE_ACCEPTANCE_PROCESS_POINT, isPurchaseAcceptancePassed(KPI)));
        setKPILoading((prev) => new Map(prev).set(PURCHASE_ACCEPTANCE_PROCESS_POINT, false));
    };

    const isPurchaseAcceptancePassed = (kpi: number) => {
        return kpi >= KPI_THRESHOLD[PURCHASE_ACCEPTANCE_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };

    const getKPIOfTrainingCompetencyForCurrentQuarter = (quarterAndYear: QuarterAndYear) => {
        let allAssignedOfAllUsers: AssignedDto[] = [];
        userState.users.forEach((user: UserDto) => {
            if (user.assigned) {
                allAssignedOfAllUsers = [...allAssignedOfAllUsers, ...user.assigned];
            }
        });
        const filteredAssigned = allAssignedOfAllUsers.filter((assignment) => {
            const createdAt = new Date(assignment.createdAt);
            const assignmentYear = createdAt.getFullYear();
            const assignmentQuarter = Math.floor(createdAt.getMonth() / 3) + 1;
            return assignmentYear === quarterAndYear.year && assignmentQuarter === quarterAndYear.quarter;
        });

        const { total, passed, failed, assigned, assignedYetToPass } = filteredAssigned.reduce(
            (acc: { total: number; passed: number; failed: number; assigned: number; assignedYetToPass: AssignedDto[] }, assignment) => {
                acc.total++;
                if (assignment.status === "PASSED") {
                    acc.passed++;
                } else if (assignment.status === "FAILED") {
                    acc.assignedYetToPass.push(assignment);
                    acc.failed++;
                } else if (assignment.status === "ASSIGNED") {
                    acc.assignedYetToPass.push(assignment);
                    acc.assigned++;
                }
                return acc;
            },
            { total: 0, passed: 0, failed: 0, assigned: 0, assignedYetToPass: [] }
        );
        const KPI = Number(passed / total);

        setKPIProgressMap((prev) => new Map(prev).set(TRAINING_COMPETENCY_PROCESS_POINT, convertToPercentage(KPI)));
        setKPIStatus((prev) => new Map(prev).set(TRAINING_COMPETENCY_PROCESS_POINT, isTrainingCompetencyPassed(KPI)));
    };

    const isTrainingCompetencyPassed = (kpi: number) => {
        return kpi == KPI_THRESHOLD[TRAINING_COMPETENCY_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };

    const loadDataOfSOPsReviewTimelyCompletionOfReviews = async () => {
        setKPILoading((prev) => new Map(prev).set(SOP_REVIEW_PROCESS_POINT, true));
        const data = await getSOPsDocumentAPI();

        const numberOfCompletionReviewsKPI = data.filter(pageIsReviewed).length;
        const numberOfUncompletedDocuments = data.filter((data) => !data.reviewDate).length;
        const timeCompletionReviewsKPI = numberOfCompletionReviewsKPI / (data.length - numberOfUncompletedDocuments);
        setKPIProgressMap((prev) => new Map(prev).set(SOP_REVIEW_PROCESS_POINT, convertToPercentage(timeCompletionReviewsKPI)));
        setTimelyReviewKPIData(data);
        setKPIStatus((prev) => new Map(prev).set(SOP_REVIEW_PROCESS_POINT, isSOPReviewPassed(timeCompletionReviewsKPI)));
        setKPILoading((prev) => new Map(prev).set(SOP_REVIEW_PROCESS_POINT, false));
    };

    const isSOPReviewPassed = (kpi: number) => {
        return kpi == KPI_THRESHOLD[SOP_REVIEW_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };

    const getKPIOfInternalAudit = async () => {
        setKPILoading((prev) => new Map(prev).set(INTERNAL_AUDIT_FREQUENCY_PROCESS_POINT, true));
        const data = await getInternalAuditDataAPI();
        setDataIAs(data);

        const currentYear = new Date().getFullYear();
        const currentIA = data.find((data: any) => data.title.includes(currentYear));
        const numberOfInternalAuditReport = currentIA?.data?.length || 0;

        setKPIProgressMap((prev) =>
            new Map(prev).set(INTERNAL_AUDIT_FREQUENCY_PROCESS_POINT, "Number of Internal Audit Report documents: " + numberOfInternalAuditReport)
        );
        setKPIStatus((prev) => new Map(prev).set(INTERNAL_AUDIT_FREQUENCY_PROCESS_POINT, isInternalAuditPassed(numberOfInternalAuditReport)));
        setKPILoading((prev) => new Map(prev).set(INTERNAL_AUDIT_FREQUENCY_PROCESS_POINT, false));
    };

    const isInternalAuditPassed = (kpi: number) => {
        return kpi >= KPI_THRESHOLD[INTERNAL_AUDIT_FREQUENCY_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };

    const getKPIOfManagementReviews = async () => {
        setKPILoading((prev) => new Map(prev).set(MANAGEMENT_REVIEW_PROCESS_POINT, true));
        const data = await getManagementReviewsDataAPI();
        setDataMRs(data);

        const currentYear = new Date().getFullYear();
        const currentIA = data.find((data: any) => data.title.includes(currentYear));
        const numberOfManagementReviews = currentIA?.data?.length || 0;

        setKPIProgressMap((prev) =>
            new Map(prev).set(MANAGEMENT_REVIEW_PROCESS_POINT, "Number of Management Reviews documents: " + numberOfManagementReviews)
        );
        setKPIStatus((prev) => new Map(prev).set(MANAGEMENT_REVIEW_PROCESS_POINT, isManagementReviewsPassed(numberOfManagementReviews)));
        setKPILoading((prev) => new Map(prev).set(MANAGEMENT_REVIEW_PROCESS_POINT, false));
    };

    const isManagementReviewsPassed = (kpi: number) => {
        return kpi >= KPI_THRESHOLD[MANAGEMENT_REVIEW_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };

    const getKPIOfDeviceManagement = async () => {
        setKPILoading((prev) => new Map(prev).set(DEVICE_MANAGEMENT_PROCESS_POINT, true));
        const data = await getDeviceManagementAPI();

        const workingDevices = data.filter((device) => device.deviceStatus.toLocaleLowerCase() !== OUT_OF_SERVICE_STATUS.toLocaleLowerCase());
        const KPI = computeDeviceManagementKPI(workingDevices);
        setDeviceManagementData(data);

        setKPIProgressMap((prev) => new Map(prev).set(DEVICE_MANAGEMENT_PROCESS_POINT, `${convertToPercentage(KPI)}`));
        setKPIStatus((prev) => new Map(prev).set(DEVICE_MANAGEMENT_PROCESS_POINT, isDeviceManagementPassed(KPI)));
        setKPILoading((prev) => new Map(prev).set(DEVICE_MANAGEMENT_PROCESS_POINT, false));
    };

    const isDeviceManagementPassed = (kpi: number) => {
        return kpi == KPI_THRESHOLD[DEVICE_MANAGEMENT_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };

    const getKPIOfNumberOfCreatedAndResolved = async () => {
        setKPILoading((prev) => new Map(prev).set(NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT, true));

        const currentYear = new Date().getFullYear();

        const currentQuarter = Math.floor(new Date().getMonth() / 3) + 1;
        const data = await getNumberOfCreatedAndResolvedDataByQuarterAPI(currentYear, currentQuarter);
        const selectedQuarter = findCurrentQuarter(data[0][LIST_PROJECT_KEY[0]][currentYear.toString()], currentYear, currentQuarter);
        if (!selectedQuarter) {
            setKPIProgressMap((prev) => new Map(prev).set(NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT, "No current quarter data"));
            setKPIStatus((prev) => new Map(prev).set(NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT, KPI_STATUS.NOT_FOUND));
            setKPILoading((prev) => new Map(prev).set(NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT, false));
            return;
        }
        const displayData = data?.map((data: any, index: number) => {
            const projectKey = LIST_PROJECT_KEY[index];
            const projectData = data?.[projectKey]?.[currentYear]?.[selectedQuarter || BLANK_STRING];

            if (projectData) {
                return {
                    projectKey,
                    ...projectData,
                };
            }

            return {
                projectKey,
                created: 0,
                completed: 0,
                placeHolder: 0,
                total: 0,
            };
        });

        const KPI =
            displayData.reduce((acc: number, data: any) => {
                return acc + data.completed;
            }, 0) /
            displayData.reduce((acc: number, data: any) => {
                return acc + data.total - data.placeHolder;
            }, 0);
        setNumberOfCreatedAndResolvedData(data);
        setKPIProgressMap((prev) => new Map(prev).set(NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT, `${convertToPercentage(KPI)}`));
        setKPIStatus((prev) => new Map(prev).set(NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT, isNumberOfCreatedAndResolvedPassed(KPI)));
        setKPILoading((prev) => new Map(prev).set(NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT, false));
    };

    const isNumberOfCreatedAndResolvedPassed = (kpi: number) => {
        return kpi >= KPI_THRESHOLD[NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT] ? KPI_STATUS.PASSED : KPI_STATUS.FAILED;
    };

    const pageIsReviewed = (data: TableRowData) => {
        return data.isPageReviewed;
    };

    // const renderSupplierPerformanceRow = () => {
    //     return (
    //         <tr>
    //             <td>
    //                 <a href="https://pascallqms.atlassian.net/wiki/spaces/QMS/pages/1247903925/L2-SP-005+Supplier+Control">L2-SP-005 Supplier Control</a>
    //             </td>
    //             <td>{convertToPercentage(supplierPerformanceKPI)}</td>
    //             <td>Supplier performance</td>
    //             <td>Timely completion of supplier Performance score</td>
    //             <td>Annual</td>
    //             <td>QA</td>
    //             <td>Management Review</td>
    //             <td> Data collected from
    //                 <a href="https://pascallqms.atlassian.net/wiki/spaces/QMSFIL/pages/1890156672"> L4-LOG-015 Supplier Monitoring Sheet</a>
    //             </td>
    //             <td>100% of Class B & C suppliers scored by the end of the calendar year.</td>
    //             <td>N/A</td>
    //             <td>Time series statistics</td>
    //             <td onClick={() => showSidebar(null)}>
    //                 <button>View</button>
    //             </td>
    //         </tr>
    //     );
    // }
    function getKpiRowClass(reviewProcessPoint: string) {
        const status = kpiStatus.get(reviewProcessPoint);
        switch (status) {
            case KPI_STATUS.NOT_FOUND:
                return "kpi-row-not-found";
            case KPI_STATUS.FAILED:
                return "kpi-row-failed";
            default:
                return "kpi-row-passed";
        }
    }
    const getKPITableRows = (): KPIRow[] => {
        return KPI_LIST.map((item: KPI_MAP, index: number) => {
            const kpi = item.data;
            const reviewProcessPoint = item.reviewProcessPoint;
            const pageUrl = item.pageUrl;
            const kpiProgressMapItem = kpiProgressMap.get(reviewProcessPoint);
            return {
                renderRow: () =>
                    pageUrl ? (
                        <tr
                            className={getKpiRowClass(reviewProcessPoint)}
                            style={{
                                position: "relative",
                            }}
                        >
                            <td>{index + 1}</td>
                            <td>
                                <a href={kpi.relatedSOP.link}>{kpi.relatedSOP.name}</a>
                            </td>
                            <td> {kpiLoading.get(reviewProcessPoint) ? <LoadingPage /> : kpiProgressMapItem} </td>
                            <td>{kpi.kpi}</td>
                            <td>{kpi.processPoint}</td>
                            <td
                                style={{
                                    position: "sticky",
                                    right: "0",
                                }}
                            >
                                {kpiLoading.get(reviewProcessPoint) ? (
                                    <LoadingPage />
                                ) : (
                                    <Button
                                        onClick={() => {
                                            showSidebar(reviewProcessPoint, pageUrl || BLANK_STRING);
                                        }}
                                    >
                                        View
                                    </Button>
                                )}
                            </td>
                        </tr>
                    ) : (
                        <></>
                    ),
            };
        });
    };

    const renderKPITable = () => {
        return <KPITable tableRows={getKPITableRows()} />;
    };

    const getKPITimelyReviewSidebarDisplay = () => {
        return <div className="sop-review">{renderTableOfTimelyReviewKPI()}</div>;
    };

    const renderTableOfTimelyReviewKPI = () => {
        return <SOPReview isDashboard={true} timelyReviewKPIData={timelyReviewKPIData} />;
    };

    const renderPageCAPAForSidebar = () => {
        return <CAPAManagement isDashboard={true} dataCAPAs={dataCAPAs.closedCAPAs} openCAPAs={dataCAPAs.openCAPAs} />;
    };

    const renderTrainingManagementForSidebar = () => {
        return <TrainingManagement isDashboard={true} dataTRCs={dataTRCs} />;
    };

    const renderTrainingCompetencyForSidebar = () => {
        return <TrainingCompetency isDashboard={true} />;
    };

    const renderPurchaseAcceptanceForSidebar = () => {
        return <PurchaseAcceptance isDashboard={true} dataPAs={dataPAs} />;
    };

    const renderNonconformanceAndInvestigationForSidebar = () => {
        return <NonconformanceAndInvestigation isDashboard={true} dataNAIs={dataNAIs}></NonconformanceAndInvestigation>;
    };

    const renderInternalAuditForSidebar = () => {
        return <InternalAudit isDashboard={true} dataIAs={dataIAs}></InternalAudit>;
    };

    const renderManagementReviewsForSidebar = () => {
        return <ManagementReviews isDashboard={true} dataMRs={dataMRs}></ManagementReviews>;
    };
    const renderDeviceManagementForSidebar = () => {
        return <DeviceManagement isDashboard={true} deviceManagementData={deviceManagementData}></DeviceManagement>;
    };

    const renderNumberOfCreatedAndResolvedForSidebar = () => {
        return <NumberOfCreatedAndResolved isDashboard={true} dataNumberOfCreatedAndResolved={NumberOfCreatedAndResolvedData} />;
    };
    const getSidebarContentBasedOnReviewProcessPoint = (reviewProcessPoint: string) => {
        switch (reviewProcessPoint) {
            case SOP_REVIEW_PROCESS_POINT:
                return getKPITimelyReviewSidebarDisplay();
            case CAPA_MANAGEMENT_PROCESS_POINT:
                return renderPageCAPAForSidebar();
            case TRAINING_MANAGEMENT_PROCESS_POINT:
                return renderTrainingManagementForSidebar();
            case TRAINING_COMPETENCY_PROCESS_POINT:
                navigate(`/${APP_URLS.TRAINING_COMPETENCY}`);
                return;
            case PURCHASE_ACCEPTANCE_PROCESS_POINT:
                return renderPurchaseAcceptanceForSidebar();
            case NONCONFORMANCE_AND_INVESTIGATION_PROCESS_POINT:
                return renderNonconformanceAndInvestigationForSidebar();
            case INTERNAL_AUDIT_FREQUENCY_PROCESS_POINT:
                return renderInternalAuditForSidebar();
            case MANAGEMENT_REVIEW_PROCESS_POINT:
                return renderManagementReviewsForSidebar();
            case DEVICE_MANAGEMENT_PROCESS_POINT:
                return renderDeviceManagementForSidebar();
            case NUMBER_OF_CREATED_VS_RESOLVED_ISSUES_PROCESS_POINT:
                return renderNumberOfCreatedAndResolvedForSidebar();
            default:
                return null;
        }
    };

    const renderSidebarContent = (reviewProcessPoint: string, pageUrl: string) => {
        return (
            <div className="sidebar-content">
                <Button style={{ position: "absolute", top: "10%", right: "50px" }} onClick={() => window.open(`/${pageUrl}`)}>
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare}></FontAwesomeIcon>
                </Button>
                {getSidebarContentBasedOnReviewProcessPoint(reviewProcessPoint)}
            </div>
        );
    };

    const showSidebar = (reviewProcessPoint: string, pageUrl: string) => {
        sidebarRef.current?.setShowSidebar(renderSidebarContent(reviewProcessPoint, pageUrl));
    };

    const renderHiddenSidebar = () => <Sidebar ref={sidebarRef} />;

    return (
        <div>
            {renderKPITable()}
            {renderHiddenSidebar()}
        </div>
    );
};

export default DashboardPage;
